
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"M13.758 14.572H2.142A1.393 1.393 0 01.75 13.18V2.5c0-.768.624-1.392 1.392-1.392h11.616c.768 0 1.392.624 1.392 1.392v10.68c0 .768-.624 1.392-1.392 1.392z","fill":"#FCEB23"}}),_c('path',{attrs:{"d":"M4.338 6.928a.592.592 0 01-.6-.588v-.672c0-.336.276-.6.6-.6.324 0 .6.276.6.6v.66c0 .336-.264.6-.588.6h-.012zm3.744 5.34a4.94 4.94 0 01-1.62-.276 5.781 5.781 0 01-2.628-1.872.61.61 0 01.108-.852.595.595 0 01.84.096s0 .012.012.012c1.08 1.368 2.892 2.004 4.308 1.524 1.32-.456 2.04-1.764 2.04-3.684V5.668c0-.336.264-.6.6-.6.336 0 .6.264.6.6v1.548c0 2.448-1.044 4.2-2.856 4.824a4.303 4.303 0 01-1.404.228z","fill":"#040505"}})])])
          )
        }
      }
    